import { Icon } from '@mui/material'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'

function Tips({ tips }) {
    return (
        <MDBox>
            {tips && tips.map((tip, index) => {
                const { text, severity = 'info' } = typeof tip === 'string' ? { text: tip } : tip

                return (
                    <MDBox
                        display="flex"
                        alignItems="center"
                        gap={1}
                        key={index}
                        data-testid={`tip-${severity}`}
                    >
                        <Icon color={severity}>{severity}</Icon>
                        <MDTypography color={severity} variant="body2">{text}</MDTypography>
                    </MDBox>
                )
            })}
        </MDBox>
    )
}

export default Tips
